<script setup>
import { computed, ref } from 'vue';
import { isSafari } from '@/Utils/device';

const props = defineProps({
	book: Object,
	dark: {
		type: Boolean,
		default: false
	}
});

const showDescription = ref(false);

</script>

<template>
	<div v-if="props.book?.description" class="BookDescription">
		<div :class="[
			'overflow-hidden',
			showDescription 
				? (props.dark ? 'to-white h-auto' : 'to-primary-dark h-auto') 
				: 'to-transparent h-gr-double-7',
			isSafari
				? (props.dark ? 'text-white' : '')
				: (props.dark ? 'bg-clip-text bg-gradient-to-b from-white text-transparent' : 'bg-clip-text bg-gradient-to-b from-primary-dark text-transparent'),
		]">
			<div v-html="props.book.description" class="text-sm"></div>
		</div>
		<button
			class="link text-xs underline focus:ring-0"
			:class="props.dark ? 'text-primary-200 hover:text-primary-100 focus:text-primary-100' : 'text-primary-500 hover:text-primary-700 focus:text-primary-700'"
			@click="showDescription = !showDescription">
			<span class="mr-gr-2">{{ showDescription ? 'Less' : 'More' }}</span><span
				:class="['inline-block duration-200', showDescription ? 'rotate-180' : 'rotate-0']"><i
					class="fa fa-sm fa-fw fa-chevron-down"></i></span>
		</button>
	</div>
</template>